import { newSortingOptions } from './filter-helpers'

export const DEFAULT_ITEMS_PER_PAGE = 16

export const SORTING_FILTER = 'sort'
export const SORTING_FEATURES = Object.freeze({
  FEATURED: 'featured',
  BESTSELLER: 'bestseller',
  PRICE: 'price',
})
export const SORTING_ORDER = Object.freeze({
  ASC: 'asc',
  DESC: 'desc',
})
export const SORTING_OPTIONS = Object.freeze({
  featured: newSortingOptions(SORTING_FEATURES.FEATURED, SORTING_ORDER.DESC, 'featured'),
  bestseller: newSortingOptions(SORTING_FEATURES.BESTSELLER, SORTING_ORDER.DESC, 'bestseller'),
  lowprice: newSortingOptions(SORTING_FEATURES.PRICE, SORTING_ORDER.ASC, 'lowprice'),
  highprice: newSortingOptions(SORTING_FEATURES.PRICE, SORTING_ORDER.DESC, 'highprice'),
})

export const FILTER_TYPE = Object.freeze({
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  SIZE: 'size',
})

export const PRODUCT_TYPE_FILTERS = Object.freeze({
  EXPLORE: 'product',
  CLASSICS: 'product_classics',
})

export const FILTER_LEVEL = Object.freeze({
  ITEM: 'item',
  VARIANT: 'variant',
})

export const PAGINATION_FILTER = 'page'
export const PAGINATION_LAST_PAGE = 'last'
